export const mutation_get_document = `
mutation getJsReportDocument($data: String!) {
    getJsReportDocument(data: $data) {
        value
    }
}`;
export const mutation_get_document_and_save = `
mutation getJsReportDocumentAndSave($data: String!) {
    getJsReportDocumentAndSave(data: $data) {
        fileName
        fileType
        fileUrl
    }
}`;